import { gql } from '@apollo/client';
import { CODE_FRAGMENT} from '../../shared/fragments';

export const FETCH_ALL_PROCEDURES_QUERY = gql`
  query fetchAllProcedures(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllProcedures(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      procedureList
      count
    }
  }
`;

export const FETCH_PROCEDURE_BY_ID = gql`
  query fetchProceDureByID($procedureId: String) {
    fetchProcedureById(procedureId: $procedureId) {
      procedure
      docArn
      documentReferenceId
    }
  }
`;

export const FETCH_RELATED_PROCEDURES = gql`
  query fetchRelatedProcedures(
    $relatedResourceId: String
    $relatedResourceType: String
  ) {
    fetchRelatedProcedures(
      resourceId: $relatedResourceId
      resourceType: $relatedResourceType
    ) {
      id
      code {
        ...code
      }
    }
  }
  ${CODE_FRAGMENT}
`;
